import loadable from '@loadable/component';
import { WithLazyHydration } from '../../WithLazyHydration';

const ImageGroupLoadable = loadable(() => import('./ImageGroup'), {
  resolveComponent: components => components.ImageGroup
});

export const ImageGroup = WithLazyHydration(ImageGroupLoadable, {
  name: 'ImageGroup'
});
